/**
 * Password validation regex patterns
 * Each regex checks for a specific password requirement
 */
export const PasswordValidation = {
  // Must contain at least one lowercase letter
  lowercaseRegex: /^.*[a-z].*$/,

  // Must contain at least one uppercase letter
  uppercaseRegex: /^.*[A-Z].*$/,

  // Must contain at least one digit
  digitRegex: /^.*\d.*$/,

  // Must contain at least one special character
  specialCharRegex: /^.*[!@#$%^&*(),.?":{}|<>].*$/,

  // Must be at least 8 characters long
  minLengthRegex: /^.{8,}$/,

  // Must not exceed 50 characters
  maxLengthRegex: /^.{0,50}$/,

  // Complete password validation
  // Must be 8-50 characters and contain uppercase, lowercase, number, and special character
  completeRegex:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,50}$/,
};

export const PASSWORD_VALIDATIONS = {
  minLength: {
    regex: PasswordValidation.minLengthRegex,
    messageId: "password-validation-message-min-length",
  },
  maxLength: {
    regex: PasswordValidation.maxLengthRegex,
    messageId: "password-validation-message-max-length",
  },
  lowercase: {
    regex: PasswordValidation.lowercaseRegex,
    messageId: "password-validation-message-lowercase",
  },
  uppercase: {
    regex: PasswordValidation.uppercaseRegex,
    messageId: "password-validation-message-uppercase",
  },
  digit: {
    regex: PasswordValidation.digitRegex,
    messageId: "password-validation-message-digit",
  },
  specialChar: {
    regex: PasswordValidation.specialCharRegex,
    messageId: "password-validation-message-special",
  },
};

// Used in registration screen for now
// Will be updated to use individual validations when new registration modal is implemented
// TODO: remove this then
// Password must be 8-50 characters long and contain at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character
export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,50}$/;
